export enum EXAM_TYPE {
  LABORATORY = 'L',
  PATHOLOGY = 'P',
  RADIOLOGY = 'N'
}
